
const styles = {
    // --- ส่วนโครงสร้างหน้าและกรอบภายนอก ---
    modalContainer: {
        width: "100%",
        maxWidth: "550px",
        backgroundColor: "#ffffff",
        padding: "32px 24px",
        borderRadius: "16px",
        boxSizing: "border-box",
        fontFamily: "'Sarabun', sans-serif",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },

    // --- ส่วนข้อความหัวข้อ (Typography) ---
    mainTitle: {
        fontSize: "24px",
        fontWeight: "700",
        color: "#000000",
        marginBottom: "8px",
        textAlign: "center",
        letterSpacing: "-0.3px"
    },
    subTitle: {
        fontSize: "16px",
        fontWeight: "500",
        color: "#333333",
        marginBottom: "24px",
        textAlign: "center",
        opacity: 0.6
    },

    // --- แถบแจ้งเตือนสีเขียว (Green Banner Box) ตามรูปภาพ image_65861d.png ---
    greenBanner: {
        width: "100%",
        backgroundColor: "#edf7f2", // สีเขียวมิ้นต์อ่อนด้านใน
        border: "1px solid #7bc69e", // เส้นขอบสีเขียวอ่อน
        borderRadius: "14px",
        display: "flex",
        alignItems: "stretch", // ให้ฝั่งไอคอนขยายเต็มความสูง
        overflow: "hidden",
        marginBottom: "28px",
        minHeight: "72px"
    },
    bannerIconWrapper: {
        backgroundColor: "#5cb887", // พื้นหลังไอคอนฝั่งซ้ายสีเขียวเข้ม
        width: "56px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
    },
    bannerTextWrapper: {
        padding: "12px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flex: 1
    },
    bannerContentText: {
        fontSize: "14px",
        fontWeight: "600",
        color: "#2a704d", // ตัวหนังสือสีเขียวเข้มของกสิกร
        textAlign: "center",
        lineHeight: "1.6",
        margin: 0
    },


};
export const Section1 = ({ t }) => {
    return (<>
        <h2 style={styles.mainTitle}>{t("Confirm access")}</h2>
        <p style={styles.subTitle}>{t("ด้วยแอปพลิเคชัน K BIZ ของผู้ใช้งาน")}</p>
        {/* แถบคำแนะนำสีเขียว (แกะจากรูปภาพภาพย่อย) */}
        <div style={styles.greenBanner}>
            <div style={styles.bannerIconWrapper}>
                {/* ไอคอนรูปโทรศัพท์มือถือ */}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
                    <line x1="12" y1="18" x2="12.01" y2="18"></line>
                </svg>
            </div>
            <div style={styles.bannerTextWrapper}>
                <p style={styles.bannerContentText}>
                    {t("kbiz_scan_instruction")}
                </p>
            </div>
        </div>
    </>)
}

export const Section2 = ({ t }) => {
    return (<>
        <span className="text-red-500 font-medium my-1 text-xs">
            {t("timeout_message")}
        </span>
    </>)
}

export const Section3 = ({ t }) => {
    return (<>
        <span className="text-sm text-gray-500 m-0">{t("please_operate_within")}</span>

    </>)
}

export const Section4 = ({ t }) => {
    return (<>
        <p className="text-sm text-red-500 font-semibold m-0">
            {t("qr_expired")}
        </p>
    </>)
}

export const Section5 = ({ t }) => {
    return (<>
        <p style={{ fontSize: 11 }} className="text-gray-400 leading-relaxed m-0">
            {t("kbiz_download_footer_tip")}
        </p>
    </>)
}